export const SSAFY9_CODE = "CREATE2309";
export const SSAFY10_CODE = "CREATE2310";
export const SSAFY11_CODE = "CREATE2411";

export const SSAFY9_ORGANIZATION = [
  "전체",
  "서울1",
  "서울2",
  "서울3",
  "서울4",
  "서울5",
  "서울6",
  "서울7",
  "서울8",
  "서울9",
  "서울10",
  "서울11",
  "서울12",
  "서울13",
  "서울14",
  "서울15",
  "서울16",
  "서울17",
  "서울18",
  "서울19",
  "서울20",
  "서울21",
  "서울22",
  "대전1",
  "대전2",
  "대전3",
  "대전4",
  "대전5",
  "대전6",
  "대전7",
  "대전8",
  "광주1",
  "광주2",
  "광주3",
  "광주4",
  "광주5",
  "광주6",
  "구미1",
  "구미2",
  "구미3",
  "구미4",
  "구미5",
  "구미6",
  "부산1",
  "부산2",
  "부산3",
  "부산4",
];

export const SSAFY10_ORGANIZATION = [
  "전체",
  "서울1",
  "서울2",
  "서울3",
  "서울4",
  "서울5",
  "서울6",
  "서울7",
  "서울8",
  "서울9",
  "서울10",
  "서울11",
  "서울12",
  "서울13",
  "서울14",
  "서울15",
  "서울16",
  "서울17",
  "서울18",
  "서울19",
  "서울20",
  "서울21",
  "서울22",
  "대전1",
  "대전2",
  "대전3",
  "대전4",
  "대전5",
  "대전6",
  "대전7",
  "대전8",
  "광주1",
  "광주2",
  "광주3",
  "광주4",
  "광주5",
  "광주6",
  "구미1",
  "구미2",
  "구미3",
  "구미4",
  "구미5",
  "구미6",
  "부울경1",
  "부울경2",
  "부울경3",
  "부울경4",
];

export const SSAFY11_ORGANIZATION = [
  "전체",
  "서울1",
  "서울2",
  "서울3",
  "서울4",
  "서울5",
  "서울6",
  "서울7",
  "서울8",
  "서울9",
  "서울10",
  "서울11",
  "서울12",
  "서울13",
  "서울14",
  "서울15",
  "서울16",
  "서울17",
  "서울18",
  "서울19",
  "서울20",
  "서울21",
  "서울22",
  "대전1",
  "대전2",
  "대전3",
  "대전4",
  "대전5",
  "대전6",
  "대전7",
  "대전8",
  "광주1",
  "광주2",
  "광주3",
  "광주4",
  "광주5",
  "광주6",
  "구미1",
  "구미2",
  "구미3",
  "구미4",
  "구미5",
  "구미6",
  "부울경1",
  "부울경2",
  "부울경3",
  "부울경4",
];
